export default {
    navOpen: true,
    footerOpen: true,
};